import { render, staticRenderFns } from "./ModalAsignacion.vue?vue&type=template&id=601413c6&"
import script from "./ModalAsignacion.vue?vue&type=script&lang=ts&"
export * from "./ModalAsignacion.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAsignacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('601413c6', component.options)
    } else {
      api.reload('601413c6', component.options)
    }
    module.hot.accept("./ModalAsignacion.vue?vue&type=template&id=601413c6&", function () {
      api.rerender('601413c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudStock/ModalAsignacion.vue"
export default component.exports